import component from './communication-field.vue';
import './communication-field.sass'

export default component